import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

export const sendFileUser = (body) => {
  const formData = new FormData()
  formData.append('idoppaction', body.idoppaction)
  formData.append('file', body.file)
  formData.append('idfile', body.idfile)

  return axios.post(API_URL + '/ctmopportunity/sendFileactionuser', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

const loadOpportunity = (idopportunity) => {
  return axios.get(API_URL + '/ctmopportunity', {
    params: {
      querysearch: `idopportunity:eq(${idopportunity})`,
      fetch: `idfundingpkgmaster.idlender,idmerchant.identerprise.idoperator.iduser`,
    },
  })
}

const changeState = (opportunity) => {
  return axios.post(API_URL + '/ctmopportunity/changestatusopportunity', opportunity)
}

const getOpportunityEvaluation = (idopportunity) => {
  return axios.get(API_URL + '/ctmopportunity/getevaluation', {
    params: {
      idopportunity: idopportunity,
    },
  })
}

const getEvaluationJSON = (idopportunity) => {
  return axios.get(API_URL + '/ctmopportunity/getevaluationjson', {
    params: {
      idopportunity: idopportunity,
    },
  })
}

const getHistory = (idopportunity) => {
  return axios.get(API_URL + '/ctmopportunity/gethistory/' + idopportunity)
}

const getOpportunityconfig = (idopportunity) => {
  return axios.get(`${API_URL}/ctmopportunityconfig/ctmopportunity/${idopportunity}`)
}

export const updateOpp = (opportunity) => {
  return axios.put(API_URL + '/ctmopportunity', opportunity)
}

// Métodos relacionados con el antiguo Provisional
const getPrequalificationResults = (idprovisionalcustomer, doexperian) => {
  return axios.get(API_URL + '/ctmprequalification/prequalificationresults', {
    params: { idprovisionalcustomer, doexperian },
  })
}

const createOpportunity = (opprovisional) => {
  const tmp = {
    ...opprovisional,
    provisionalCustomer: {
      ...opprovisional.provisionalCustomer,
      identifiertype: 'DNI',
    },
  }
  return axios.post(API_URL + '/ctmprovisionalcustomer', tmp)
}

const loadLenders = (idprovisionalcustomer) => {
  return axios.get(API_URL + `/ctmprovisionalstate/statesbyprovisional/${idprovisionalcustomer}`)
}

const approveLender = (lenderList) => {
  return axios.put(API_URL + '/ctmprovisionalstate/approve', lenderList)
}

const loadOpportunities = (params) => {
  let query = []
  if (params?.querysearch) {
    query = params.querysearch
  }
  let sort = `desc(dateentry)`
  if (params?.sort) {
    sort = params.sort
  }
  return axios.get(API_URL + '/ctmopportunity', {
    params: { ...params, querysearch: query, sort },
  })
}

export const downloadCsvOpportunities = (reportRequest) => {
  return axios.post(API_URL + '/ctmopportunity/download', reportRequest)
}

export const api = {
  loadOpportunities,
  loadOpportunity,
  createOpportunity,
  changeState,
  getOpportunityEvaluation,
  getEvaluationJSON,
  getHistory,
  getOpportunityconfig,
  updateOpp,
  loadLenders,
  approveLender,
  getPrequalificationResults,
  downloadCsvOpportunities,
}

export default api
